import { useMutation } from '@tanstack/react-query'
import { getHeaders } from 'services/api/utils'
import { getAdminUiUrlByPlatform } from 'utils/adminUi'
import { getPlatform } from 'utils/token/token'

const BASE_URL = getAdminUiUrlByPlatform(getPlatform())

const exportReport = async ({ adAccountId, startDate, endDate, groupBy, campaigns, ads, statuses }) => {
  const response = await fetch(
    `${BASE_URL}/api/AdInsightsReport`,
    getHeaders('POST', {
      ad_account_id: adAccountId,
      start_date: startDate.toLocaleDateString('en-CA'),
      end_date: endDate.toLocaleDateString('en-CA'),
      source: 'meta',
      group_by: groupBy,
      ad_ids: ads.join(),
      campaign_ids: campaigns.join(),
      statuses: statuses.join(),
    }),
  ).then((res) => res.json())
  return response
}

const downloadReport = async (exportId) => {
  window.open(`${getAdminUiUrlByPlatform(getPlatform(), false)}/api/AdInsightsReport?guidurl=${exportId}`)
}

function useExportAdsReport() {
  return useMutation({
    mutationFn: ({ adAccountId, startDate, endDate, groupBy, campaigns, ads, statuses }) =>
      exportReport({ adAccountId, startDate, endDate, groupBy, campaigns, ads, statuses }),
    onSuccess: (result) => {
      downloadReport(result)
    },
  })
}

export default useExportAdsReport
